export const headerHeight = {
    desktop: '80px',
    mobile: '65px',
    cadMobile: '60px',
    cadDesctop: '80px',
}
